import React from "react";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  card: {
    margin: "auto",
    width: "100%",
    flexGrow: 1,
  },
});

const AlunoTurmaProfileView = ({ alunoTurma, handleChangeAlunoTurma }) => {
  const classes = useStyles();

  return (
    <Card className={classes.card} variant="outlined">
      <CardContent>
        <Grid container spacing={3}>
          <Grid size={3}>
            <Typography variant="body1" color="textSecondary" gutterBottom>
              Turma
            </Typography>
            <Typography variant="body1">
              {alunoTurma ? alunoTurma.turma.descricao : ""}
            </Typography>
          </Grid>
          <Grid size={3}>
            <Typography variant="body1" color="textSecondary" gutterBottom>
              Nº Chamada
            </Typography>
            <Typography variant="body1">
              {alunoTurma ? alunoTurma.numeroChamada : ""}
            </Typography>
          </Grid>
          <Grid size={3}>
            <Typography variant="body1" color="textSecondary" gutterBottom>
              Nome
            </Typography>
            <Typography variant="body1">
              {alunoTurma ? alunoTurma.aluno.nome : ""}
            </Typography>
          </Grid>
        </Grid>
        <CardActions>
          <Button
            color="secondary"
            onClick={handleChangeAlunoTurma}
            size="small"
            variant="contained"
          >
            Trocar Aluno Turma
          </Button>
        </CardActions>
      </CardContent>
    </Card>
  );
};

export default AlunoTurmaProfileView;
